import { CreateDocumentFlow } from "./CreateDocumentFlow";

export function LegacyDocumentCreation() {
	return <CreateDocumentFlow variant="legacy" />;
}
